import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "data-cy": "post-settlement-actions" }
const _hoisted_2 = {
  class: "font-weight-bold text-grey mb-1 d-flex align-center gap-1 text-caption",
  style: {"text-transform":"uppercase","letter-spacing":"0.05em"}
}
const _hoisted_3 = { class: "d-flex align-center gap-2 flex-wrap mb-1" }
const _hoisted_4 = { class: "d-flex align-center gap-1 text-body-2 font-weight-medium text-green-800" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = {
  key: 0,
  class: "text-caption text-grey-darken-1",
  style: {"font-style":"italic"}
}
const _hoisted_7 = {
  key: 0,
  class: "text-caption text-grey-darken-1 mt-1",
  style: {"font-style":"italic"}
}
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = { class: "mt-1" }
const _hoisted_10 = {
  key: 2,
  class: "text-caption mt-1 text-error",
  "data-cy": "invoice-error"
}
const _hoisted_11 = {
  class: "text-grey-darken-1 mb-2 d-flex align-center flex-wrap text-body-2",
  style: {"gap":"4px"}
}
const _hoisted_12 = { class: "font-weight-medium" }
const _hoisted_13 = { class: "font-weight-medium" }
const _hoisted_14 = { style: {"max-width":"300px"} }
const _hoisted_15 = { class: "d-flex align-center gap-2 flex-wrap mb-1" }
const _hoisted_16 = { class: "d-flex align-center gap-1 text-body-2 font-weight-medium text-green-800" }
const _hoisted_17 = {
  key: 0,
  class: "text-caption text-grey-darken-1",
  style: {"font-style":"italic"}
}
const _hoisted_18 = {
  key: 4,
  class: "text-caption mt-1 text-error",
  "data-cy": "trust-error"
}
const _hoisted_19 = {
  key: 0,
  class: "text-grey-darken-1 mb-2 text-body-2"
}
const _hoisted_20 = { class: "font-weight-medium" }
const _hoisted_21 = { class: "d-flex align-center gap-2 flex-wrap mb-1" }
const _hoisted_22 = { class: "d-flex align-center gap-1 text-body-2 font-weight-medium text-green-800" }
const _hoisted_23 = {
  key: 0,
  class: "text-caption text-grey-darken-1",
  style: {"font-style":"italic"}
}
const _hoisted_24 = {
  class: "text-caption text-grey-darken-1 mt-1",
  style: {"font-style":"italic"}
}
const _hoisted_25 = {
  key: 4,
  class: "text-caption mt-1 text-error",
  "data-cy": "qbo-error"
}

import { computed } from 'vue';
import LlTooltip from '@/components/LlTooltip.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlIcon from '@/components/LlIcon.vue';
import { formatCurrency } from '@/services/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettlementPostActions',
  props: {
  /** True when settlementInvoiceId is non-null (invoice exists). */
  invoiceFinalized: { type: Boolean, default: false },
  /** True when the invoice can be finalized now (server-provided). */
  canFinalizeInvoice: { type: Boolean, default: false },
  /** True when the invoice can be undone now (server-provided). */
  canUndoInvoice: { type: Boolean, default: false },
  /** Reason finalize/undo is blocked (server-provided). */
  invoiceBlockedReason: { type: String, default: null },
  trustPaid: { type: Boolean, default: false },
  canPayFromTrust: { type: Boolean, default: false },
  canUndoTrustPayment: { type: Boolean, default: false },
  trustPaymentBlockedReason: { type: String, default: null },
  /** Reason trust-payment Undo is blocked (server-provided) — distinct from the push-blocked reason above. */
  undoTrustPaymentBlockedReason: { type: String, default: null },
  qboPushed: { type: Boolean, default: false },
  canPushClientDisbursement: { type: Boolean, default: false },
  canUndoClientDisbursement: { type: Boolean, default: false },
  disbursementBlockedReason: { type: String, default: null },
  /** Reason client-disbursement Undo is blocked (server-provided), e.g. QBO Cleared/Reconciled. */
  undoDisbursementBlockedReason: { type: String, default: null },
  invoiceAmount: { type: Number, default: null },
  netToClient: { type: Number, default: null },
  trustBalance: { type: Number, default: null },
  trustBalanceLoading: { type: Boolean, default: false },
  trustBalanceError: { type: Boolean, default: false },
  trustInsufficient: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
  savingColumn: { type: String, default: null },
  error: { type: String, default: null },
  /** 'invoice' | 'trust' | 'qbo' | null — which column shows the inline error */
  columnError: { type: String, default: null },
  /** When set, shows a stage badge in the header (e.g. 'Settlement Pending'). */
  stageBadge: { type: String, default: null },
  /** True when trust statement is being downloaded (separate from action buttons). */
  trustStatementLoading: { type: Boolean, default: false },
  /** `settlementClientAccounting` flipper: on, the tooltip drops its matter-only wording. */
  clientAccountingEnabled: { type: Boolean, default: false },
},
  emits: [
  'finalize-invoice',
  'undo-invoice',
  'pay-trust',
  'undo-trust',
  'push-qbo',
  'undo-qbo',
  'view-invoice',
],
  setup(__props) {

const props = __props;

// Drop the branch, keeping the neutral string, when the flipper goes.
const trustScopeSentence = computed(() =>
  props.clientAccountingEnabled
    ? 'Trust is the available trust balance for this settlement.'
    : 'Trust is the available client trust balance for this matter.',
);



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "4",
          class: "px-4 py-3",
          style: {"border-right":"1px solid #f0f0f0"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[11] || (_cache[11] = _createTextVNode(" 1. Finalize Invoice ", -1)),
              _createVNode(LlTooltip, { location: "top" }, {
                activator: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "13",
                    class: "cursor-pointer text-grey"
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"max-width":"260px"} }, " This invoice will be finalized immediately. The settlement wizard review replaces the standard invoice approval step. Billing period: All Time. Invoice date per firm settings. ", -1))
                ]),
                _: 1
              })
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("p", {
              class: "text-grey-darken-1 mb-2 text-body-2",
              style: {"font-style":"italic"}
            }, " Finalized immediately — wizard review replaces approval. ", -1)),
            (__props.invoiceFinalized)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(LlIcon, {
                        icon: "mdi-check-circle",
                        size: "16",
                        color: "success"
                      }),
                      _cache[12] || (_cache[12] = _createTextVNode(" Invoice Created ", -1))
                    ]),
                    (__props.canUndoInvoice)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "text-decoration-underline cursor-pointer text-body-2 font-weight-medium text-error",
                          "data-cy": "undo-invoice-link",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('undo-invoice')))
                        }, " Undo "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("a", {
                      class: "text-decoration-underline cursor-pointer text-primary",
                      "data-cy": "view-invoice-link",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('view-invoice')))
                    }, " View Invoice → ")
                  ]),
                  (!__props.canUndoInvoice && __props.invoiceBlockedReason)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.invoiceBlockedReason), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(LlSecondaryButton, {
                    color: "primary",
                    variant: "elevated",
                    size: "small",
                    loading: __props.saving && __props.savingColumn === 'invoice',
                    disabled: __props.saving || !__props.canFinalizeInvoice,
                    "data-cy": "finalize-invoice-button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('finalize-invoice')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.canUndoInvoice ? 'Retry Finalize' : 'Finalize Invoice'), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"]),
                  (!__props.canFinalizeInvoice && __props.invoiceBlockedReason)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.invoiceBlockedReason), 1))
                    : _createCommentVNode("", true),
                  (__props.canUndoInvoice)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("a", {
                            class: "text-decoration-underline cursor-pointer text-primary",
                            "data-cy": "view-invoice-link",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('view-invoice')))
                          }, " View Invoice → ")
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("a", {
                            class: "text-decoration-underline cursor-pointer text-body-2 font-weight-medium text-error",
                            "data-cy": "undo-draft-invoice-link",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('undo-invoice')))
                          }, " Undo draft invoice ")
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64)),
            (__props.columnError === 'invoice')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(__props.error), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "4",
          class: "px-4 py-3",
          style: {"border-right":"1px solid #f0f0f0"}
        }, {
          default: _withCtx(() => [
            _cache[25] || (_cache[25] = _createElementVNode("div", {
              class: "font-weight-bold text-grey mb-1 text-caption",
              style: {"text-transform":"uppercase","letter-spacing":"0.05em"}
            }, " 2. Pay from Trust ", -1)),
            _createElementVNode("p", _hoisted_11, [
              _cache[22] || (_cache[22] = _createTextVNode(" Trust: ", -1)),
              _createElementVNode("span", _hoisted_12, [
                (__props.trustBalance !== null)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_unref(formatCurrency)(__props.trustBalance)), 1)
                    ], 64))
                  : (__props.trustBalanceLoading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("…")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode("—")
                      ], 64))
              ]),
              (__props.invoiceAmount !== null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "mx-1" }, "|", -1)),
                    _cache[15] || (_cache[15] = _createTextVNode(" Inv: ", -1)),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(formatCurrency)(__props.invoiceAmount)), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(LlTooltip, { location: "top" }, {
                activator: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "13",
                    class: "cursor-pointer text-grey"
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createTextVNode(_toDisplayString(trustScopeSentence.value) + " Inv is the finalized invoice amount due. The system compares these amounts before allowing payment from trust. ", 1),
                    _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                    _cache[18] || (_cache[18] = _createTextVNode(" Trust Available: ", -1)),
                    _createElementVNode("strong", null, [
                      (__props.trustBalance !== null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(formatCurrency)(__props.trustBalance)), 1)
                          ], 64))
                        : (__props.trustBalanceLoading)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Loading...")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode("—")
                            ], 64))
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                    _cache[20] || (_cache[20] = _createTextVNode(" Invoice Due: ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(__props.invoiceAmount !== null ? _unref(formatCurrency)(__props.invoiceAmount) : '—'), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            (__props.trustPaid || __props.canUndoTrustPayment)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(LlIcon, {
                        icon: "mdi-check-circle",
                        size: "16",
                        color: "success"
                      }),
                      _cache[23] || (_cache[23] = _createTextVNode(" Paid from Trust ", -1))
                    ]),
                    (__props.canUndoTrustPayment)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "text-decoration-underline cursor-pointer text-body-2 font-weight-medium text-error",
                          "data-cy": "undo-trust-link",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('undo-trust')))
                        }, " Undo "))
                      : _createCommentVNode("", true)
                  ]),
                  (!__props.canUndoTrustPayment)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(__props.trustPaymentBlockedReason || __props.undoTrustPaymentBlockedReason || 'Undo is not available right now.'), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (!__props.invoiceFinalized)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(LlSecondaryButton, {
                      color: "primary",
                      variant: "tonal",
                      size: "small",
                      disabled: "",
                      "data-cy": "pay-trust-button-locked"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Pay " + _toDisplayString(__props.invoiceAmount !== null ? _unref(formatCurrency)(__props.invoiceAmount) : ''), 1)
                      ]),
                      _: 1
                    }),
                    _cache[24] || (_cache[24] = _createElementVNode("p", {
                      class: "text-caption text-grey-darken-1 mt-1",
                      style: {"font-style":"italic"}
                    }, "Finalize the invoice first.", -1))
                  ], 64))
                : (!__props.canPayFromTrust && !__props.trustPaid)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(LlSecondaryButton, {
                        color: "primary",
                        variant: "tonal",
                        size: "small",
                        disabled: "",
                        "data-cy": "pay-trust-button-blocked"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Pay " + _toDisplayString(__props.invoiceAmount !== null ? _unref(formatCurrency)(__props.invoiceAmount) : ''), 1)
                        ]),
                        _: 1
                      }),
                      (__props.trustPaymentBlockedReason || __props.trustInsufficient)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: _normalizeClass(["text-caption mt-1 italic", __props.trustPaymentBlockedReason ? 'text-gray-500' : 'text-orange-700'])
                          }, _toDisplayString(__props.trustPaymentBlockedReason || `Trust balance: ${__props.trustBalance !== null ? _unref(formatCurrency)(__props.trustBalance) : '—'} / Required: ${__props.invoiceAmount !== null ? _unref(formatCurrency)(__props.invoiceAmount) : '—'}`), 3))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(LlSecondaryButton, {
                      key: 3,
                      color: "primary",
                      variant: "elevated",
                      size: "small",
                      loading: __props.saving && __props.savingColumn === 'trust',
                      disabled: __props.saving,
                      "data-cy": "pay-trust-button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('pay-trust')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Pay " + _toDisplayString(__props.invoiceAmount !== null ? _unref(formatCurrency)(__props.invoiceAmount) : ''), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"])),
            (__props.columnError === 'trust')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(__props.error), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "4",
          class: "px-4 py-3"
        }, {
          default: _withCtx(() => [
            _cache[28] || (_cache[28] = _createElementVNode("div", {
              class: "font-weight-bold text-grey mb-1 text-caption",
              style: {"text-transform":"uppercase","letter-spacing":"0.05em"}
            }, " 3. Client Disbursement ", -1)),
            (__props.netToClient !== null)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                  _cache[26] || (_cache[26] = _createTextVNode(" Net to Client: ", -1)),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(formatCurrency)(__props.netToClient)), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.qboPushed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(LlIcon, {
                        icon: "mdi-check-circle",
                        size: "16",
                        color: "success"
                      }),
                      _cache[27] || (_cache[27] = _createTextVNode(" Pushed to QuickBooks ", -1))
                    ]),
                    (__props.canUndoClientDisbursement)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "text-decoration-underline cursor-pointer text-body-2 font-weight-medium text-error",
                          "data-cy": "undo-qbo-link",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('undo-qbo')))
                        }, " Undo "))
                      : _createCommentVNode("", true)
                  ]),
                  (!__props.canUndoClientDisbursement)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(__props.undoDisbursementBlockedReason || 'QuickBooks entry cannot be undone right now.'), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (!__props.canPushClientDisbursement)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(LlSecondaryButton, {
                      color: "primary",
                      variant: "tonal",
                      size: "small",
                      disabled: "",
                      "data-cy": "push-qbo-button-locked"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Submit to QuickBooks " + _toDisplayString(__props.netToClient !== null ? _unref(formatCurrency)(__props.netToClient) : ''), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", _hoisted_24, _toDisplayString(__props.disbursementBlockedReason || __props.invoiceBlockedReason || (__props.trustPaid ? 'Client disbursement cannot be pushed right now.' : 'Pay the invoice first.')), 1)
                  ], 64))
                : (_openBlock(), _createBlock(LlSecondaryButton, {
                    key: 3,
                    color: "primary",
                    variant: "elevated",
                    size: "small",
                    loading: __props.saving && __props.savingColumn === 'qbo',
                    disabled: __props.saving,
                    "data-cy": "push-qbo-button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('push-qbo')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Submit to QuickBooks " + _toDisplayString(__props.netToClient !== null ? _unref(formatCurrency)(__props.netToClient) : ''), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])),
            (__props.columnError === 'qbo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(__props.error), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})